export default "__VITE_ASSET__2604cd99__"